import React, { useState } from "react";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Eye, Monitor, Smartphone } from "lucide-react";
import { SignaturePreviewFrame } from "@/components/SignaturePreview";
import { TEMPLATES } from "@/constants/testIds";
import { PreviewViewToggle } from "@/components/templates/PreviewViewToggle";
import { RecipientPreviewSummary } from "@/components/templates/RecipientPreviewSummary";
import { useRecipientPreview } from "@/hooks/useRecipientPreview";

export function TemplatePreviewPane({ users, previewUserId, onUserChange, previewHtml, htmlContent, imageStrategy }) {
  const [view, setView] = useState("editor");
  const isRecipient = view === "recipient";
  const recipient = useRecipientPreview(htmlContent, imageStrategy, previewUserId, isRecipient);
  const html = isRecipient ? recipient.data?.html || "" : previewHtml;

  return (
    <Card className="p-5 border-slate-200 shadow-sm">
      <div className="flex items-center justify-between gap-2 mb-3 flex-wrap">
        <div className="flex items-center gap-2">
          <Eye className="w-4 h-4 text-orange-600" strokeWidth={1.75} />
          <h3 className="text-sm font-semibold text-slate-900">Vista previa</h3>
        </div>
        <PreviewViewToggle value={view} onChange={setView} />
      </div>
      <div className="mb-3">
        <Label className="text-[11px] font-semibold text-slate-500 uppercase tracking-wider">
          Usuario de referencia
        </Label>
        <Select value={previewUserId} onValueChange={onUserChange}>
          <SelectTrigger className="mt-1 focus:ring-orange-500" data-testid="preview-user-select">
            <SelectValue placeholder="Seleccionar..." />
          </SelectTrigger>
          <SelectContent>
            {users.map((u) => (<SelectItem key={u.id} value={u.id}>{u.display_name}</SelectItem>))}
          </SelectContent>
        </Select>
      </div>

      {isRecipient && <RecipientPreviewSummary data={recipient.data} loading={recipient.loading} />}

      <Tabs defaultValue="desktop">
        <TabsList className="bg-slate-100">
          <TabsTrigger value="desktop">
            <Monitor className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.75} /> Desktop
          </TabsTrigger>
          <TabsTrigger value="mobile">
            <Smartphone className="w-3.5 h-3.5 mr-1.5" strokeWidth={1.75} /> Mobile
          </TabsTrigger>
        </TabsList>
        <TabsContent value="desktop" className="mt-3">
          <SignaturePreviewFrame html={html} mode="desktop" testId={TEMPLATES.previewDesktop} />
        </TabsContent>
        <TabsContent value="mobile" className="mt-3">
          <SignaturePreviewFrame html={html} mode="mobile" testId={TEMPLATES.previewMobile} />
        </TabsContent>
      </Tabs>
    </Card>
  );
}
